<template>
  <tr>
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{
        rowIndex + 1
      }}</span>
    </td>
    <td class="form-group"  v-if="jobType == 'AUDIT_STOCK'">
       
       <div class="form-group kt-margin-0">
        <select2
          :disabled="!isEditable"
          :css-style="'width: 100%;'"
          :css-class="'form-control select-barcode-status required'"
          :id="'barcodeStatus' + _uid"
          :name="'barcodeStatus' + _uid"
          :select2-options="MbBarcodeStatusOptions"
          v-model="item.barcodeStatus"
          ref="barcodeStatus"
          @selectChange="onBarcodeStatusChange"
          data-msg-required="กรุณาเลือก"
        ></select2>
        <span class="form-text"></span>
      </div> 
      <span class="form-text"></span>
    </td>
    <td> 
      <div class="form-group kt-margin-0">
        <select2
          :disabled="!isEditable"
          :css-style="'width: 100%;'"
          :css-class="'form-control required'"
          :id="'materialCode' + _uid"
          :name="'materialCode' + _uid"
          :select2-options="materialCodeOptions"
          v-model="item.materialCode"
          ref="materialCode"
          @selectChange="onMaterialCodeChange"
          data-msg-required="กรุณาเลือกสินค้า/ทรัพย์สิน"
        ></select2>
        <span class="form-text"></span>
      </div> 
      <span
        class="text-warning"
        v-if="
          (item.selectedMaterialCodeData && !item.selectedMaterialCodeData.data.hasBarcode) && jobType != 'AUDIT_STOCK' 
        "
      >
        <i class="fa fa-exclamation-triangle"></i>
        ไม่สามารถสแกนบาร์โค้ดบน Handheld ได้
      </span>
      <div
        class="form-group kt-margin-0"
        v-if="
          item.selectedMaterialCodeData &&
            !item.selectedMaterialCodeData.data.hasBarcode &&
            (jobType == 'BORROW' || jobType == 'DESTROY')
        "
      >
        <label>โควต้าสำหรับอัพเดทสต็อก</label>
        <select2
          :disabled="!isEditable"
          :css-style="'width: 100%;'"
          :css-class="'form-control required'"
          :id="'quota' + _uid"
          :name="'quota' + _uid"
          :select2-options="quotaOptions"
          v-model="item.quotaId"
          ref="quotaOptions"
          data-msg-required="กรุณาเลือกโควต้าสำหรับอัพเดทสต็อก"
          @select2mounted="onQuotaMounted"
        ></select2>
        <span class="form-text"></span>
      </div>
    </td>
    <td class="form-group" v-if="jobType != 'AUDIT_STOCK'">
      <input
        type="text"
        class="form-control"
        placeholder="รายละเอียด"
        :readonly="!isEditable"
        v-model="item.description"
      />
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <input
        type="number"
        class="form-control required min text-right"
        min="1"
        placeholder="จำนวน"
        :readonly="!isEditable && !isEdit"
        :id="'quantity' + _uid"
        :name="'quantity' + _uid" 
        v-model="item.quantity"
        data-msg-required="กรุณากรอกจำนวน"
        data-msg-min="ต้องมีจำนวนอย่างน้อย 1 ชิ้น"
      />
      <!-- :readonly="!isEditable" --> 
      <span
        style="display: block;"
        class="text-info text-right"
        v-if="item.checkedQuantity > 0"
      >
        <i class="fa fa-qrcode"></i>
        สแกนแล้ว {{ item.checkedQuantity }} บาร์โค้ด
      </span>
      <span
        style="display: block;"
        class="text-warning"
        v-if="jobType == 'RETRIEVE_ITEM' && item.productLoanReturn"
      >
        ส่งคืน {{ item.productLoanReturn.return }} {{ item.unitName }}<br />
        ชำรุด {{ item.productLoanReturn.damaged }} {{ item.unitName }}<br />
        สูญหาย {{ item.productLoanReturn.lost }} {{ item.unitName }}
      </span>
      <span class="form-text"></span>
    </td>
     <td class="form-group" v-if="jobType == 'AUDIT_STOCK'">
      <input
        type="text"
        class="form-control"
        placeholder="รายละเอียด"
        :readonly="!isEditable"
        v-model="item.description"
      />
      <span class="form-text"></span>
    </td>
    <td class="text-center"  v-if="jobType != 'AUDIT_STOCK'">
      <span class="form-control form-control-plaintext">{{
        item.unitName
      }}</span>
    </td>
    <td class="text-center"  >
      <span v-if="jobType == 'AUDIT_STOCK'"></span>
      <button
        v-if="!isEditable && jobType != 'AUDIT_STOCK'"
        type="button"
        class="btn btn-outline-hover-info btn-elevate btn-circle btn-icon"
        title="แสดงรายการบาร์โค้ด"
        @click.prevent="onShowBarcodeClick"
      >
        <i class="text-info la la-list"></i>
      </button>
       <!-- แสดงปุ่มเฉพาะใบงานที่ไม่ได้ยกยอด (รถเร่) -->
      <button
        v-if="isEditable && (jobType != 'PICKUP' || (jobType == 'PICKUP' && item.checkedQuantity == 0))"
        type="button"
        class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
        title="ลบรายการ"
        @click.prevent="onRemoveItemClick"
      >
        <i class="text-danger la la-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import select2 from "../../Shared/Select2";

export default {
  components: {
    select2,
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true,
    },
    jobType: {
      type: String,
    },
    originLocationId: {
      type: String,
    },
    originData: {
      type: Object,
    },
    noUseSML: {
      type: Boolean,
      default: false,
    },
    parentJobType: {
      type: String,
    },
    allItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    var self = this;
    return {
      materialCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า/ทรัพย์สิน",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              productGroupId: 0,
            };

             

            // if (
            //   self.jobType == "RETRIEVE_NEW_ITEM" ||
            //   self.jobType == "PRODUCE" ||
            //   self.jobType == "REPAIR" ||
            //   self.jobType == "REPAIR_SUPPLIER" ||
            //   self.jobType == "RETURN_SUPPLIER" ||
            //   self.jobType == "RETURN" ||
            //   self.jobType == "RETURN_ADHOC" ||
            //   self.jobType == "EXCHANGE" ||
            //   self.jobType == "BORROW"
            // ) {
            //   // เครื่องและอุปกรณ์เบียร์สด
            //   query.productGroupId = 1;
            // } else if (
            //   self.jobType == "TRANSFER_TO_AGENT" ||
            //   self.jobType == "TRANSFER_TO_SHOP" ||
            //   self.jobType == "PICKUP"
            // ) {
            //   // สินค้าสำเร็จรูป
            //   query.productGroupId = 14;
            // } else if (self.jobType == "DESTROY") {
            //   if (self.originLocationId == "9901") {
            //     delete query.productGroupId;
            //   } else {
            //     // เครื่องและอุปกรณ์เบียร์สด
            //     query.productGroupId = 1;
            //     // ถ้าไม่ใช่ 9901 คลังปากเกร็ด ให้แสดงเฉพาะที่มีบาร์โค้ด
            //     query.onlyHasBarcode = true;
            //   }
            // }

            // if (self.noUseSML) {
            //   delete query.productGroupId;
            // }
            // console.log(self.jobType, self.originData);

            if (
              self.jobType == "RETRIEVE_NEW_ITEM" ||
              self.jobType == "PRODUCE" ||
              self.jobType == "TRANSFER_TO_AGENT" ||
              self.jobType == "RETRIEVE_ITEM" ||
              self.jobType == "REPAIR" ||
              self.jobType == "REPAIR_SUPPLIER" ||
              self.jobType == "PICKUP" ||
              self.jobType == "EXCHANGE" ||
              self.jobType == "RETURN" ||
              self.jobType == "RETURN_ADHOC" ||
              self.jobType == "RETURN_SUPPLIER" ||
              self.jobType == "HOLD_CHECKER"
            ) {
              delete query.productGroupId;
              query.onlyHasBarcode = true;
              if((self.parentJobType == "JOB_TYPE_RETURN" && self.jobType == "RETRIEVE_ITEM") || self.jobType == "RETURN"){
                query.excludeProductGroupId = 14;
              }
              
            } 
            else if (self.jobType == "AUDIT_STOCK") {

              // 👉 หา row ปัจจุบัน
            const $row = $(this).closest('tr'); 
            // 👉 ดึงค่าสถานะ BARCODE ใน row เดียวกัน
            const barcodeStatus = $row.find('.select-barcode-status').val(); 

              // ส่งสินค้าไปยังร้านค้าหลายแห่ง: exclude productTypeId 4,5
              delete query.productGroupId;
              query.onlyHasBarcode = false;
              // // jQuery จะ serialize เป็น excludeProductTypeIds=4&excludeProductTypeIds=5
              // // ASP.NET Core Model Binder จะรับเป็น int[] อัตโนมัติ
              query.excludeProductTypeIds = [99];
              query.barcodeStatusCode = barcodeStatus; 

            }
            else if (self.jobType == "TRANSFER_TO_MULTI_SHOP") {
              // ส่งสินค้าไปยังร้านค้าหลายแห่ง: exclude productTypeId 4,5
              delete query.productGroupId;
              query.onlyHasBarcode = false;
              // jQuery จะ serialize เป็น excludeProductTypeIds=4&excludeProductTypeIds=5
              // ASP.NET Core Model Binder จะรับเป็น int[] อัตโนมัติ
              query.excludeProductTypeIds = [4, 5];
            } else if (self.jobType == "TRANSFER_TO_SHOP") {
              if (
                self.originData &&
                self.originData.data.locationType == "AGENT" &&
                !self.originData.data.noSML &&
                !self.noUseSML
              ) {
                // ตัวแทนฯที่ใช้ SML และไม่ได้เลือก "ไม่อ้างอิงข้อมูลระบบ SML" : แสดงเฉพาะสินค้าที่มีบาร์โค้ด
                delete query.productGroupId;
                query.onlyHasBarcode = true;
              } else {
                // ตัวแทนฯที่ใช้ SML และเลือก "ไม่อ้างอิงข้อมูลระบบ SML" : แสดงทุกสินค้า ยกเว้น สินค้า PRODUCT_GROUP_ID = 14
                // ตัวแทนฯที่ไม่ใช้ SML : แสดงทุกสินค้า ยกเว้น สินค้า PRODUCT_GROUP_ID = 14
                delete query.productGroupId;
                query.excludeProductGroupId = 14;
              }
            } else if (self.jobType == "DESTROY") {
              if (
                self.originData &&
                self.originData.data.locationType == "PLANT" &&
                self.originData.id == "9901"
              ) {
                // โปรไฟล์ คลังปากเกร็ด : แสดงทุกสินค้า ยกเว้น สินค้า PRODUCT_GROUP_ID = 14
                delete query.productGroupId;
                query.excludeProductGroupId = 14;
              } else {
                // อื่นๆ : แสดงเฉพาะสินค้าที่มีบาร์โค้ด
                delete query.productGroupId;
                query.onlyHasBarcode = true;
              }
            }

            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            // ตั้งค่า traditional: true เพื่อให้ serialize array ถูกต้องสำหรับ ASP.NET Core
            // จาก excludeProductTypeIds[]=4 เป็น excludeProductTypeIds=4&excludeProductTypeIds=5
            params.traditional = true;
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      quotaOptions: {
        placeholder: "กรุณาเลือกโควต้าสำหรับตัดสต๊อค",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Quota/Select2Quota",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
       MbBarcodeStatusOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url:"/Api/Barcode/Select2BarcodeAuditStockStatus",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              all : true,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      
    };
  },
  methods: {
     
    onQuotaMounted(sender) {
      const $input = $(sender);
      $input.rules("add", {
        required: true,
        messages: {
          required: "กรุณาเลือกโควต้าสำหรับอัพเดทสต็อก",
        },
      });
    },
    onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    },
    onShowBarcodeClick(e) {
      this.$emit("showBarcode", this.rowIndex, this.item);
    },
    checkDuplicateAuditStockItem(materialCode, barcodeStatus) {
      if (this.jobType !== "AUDIT_STOCK" || !materialCode || !barcodeStatus) {
        return false;
      }
      var isDuplicate = $.grep(this.allItems, function(obj, i) {
        return obj.materialCode === materialCode && obj.barcodeStatus === barcodeStatus;
      });
      // มากกว่า 1 เพราะรวมแถวปัจจุบันด้วย
      if (isDuplicate.length > 1) {
        Swal.fire("เกิดข้อผิดพลาด", "สถานะบาร์โค้ดและสินค้า/ทรัพย์สินซ้ำกับรายการที่มีอยู่แล้ว", "warning");
        return true;
      }
      return false;
    },
    onMaterialCodeChange(id, value, data, ref) {
      if (value) {
        var selected = data[0];
        this.item.selectedMaterialCodeData = selected;
        this.item.unitName = selected.data.baseUnit;

        // Auto-select barcode status for AUDIT_STOCK based on product type
        if (this.jobType === "AUDIT_STOCK" && selected.data.productTypeId) {
          var typeId = selected.data.productTypeId;
          var statusCode, statusText;

          if (typeId === 4 || typeId === 5) {
            statusCode = "PRODUCT_BARCODE_STATUS_NOT_READY";
            statusText = "ถังเปล่า";
          } else if (typeId === 22) {
            statusCode = "PRODUCT_BARCODE_STATUS_READY_TO_SHIP";
            statusText = "ถังเต็ม";
          } else {
            statusCode = "PRODUCT_BARCODE_STATUS_OCCUPIED";
            statusText = "ระหว่างใช้งาน";
          }

          this.$refs.barcodeStatus.setSelectedData({
            id: statusCode,
            text: statusText
          });
          this.barcodeStatus = statusCode;
        }

        // ตรวจสอบซ้ำ: สถานะบาร์โค้ด + สินค้า
        if (this.checkDuplicateAuditStockItem(value, this.barcodeStatus)) {
          this.item.materialCode = null;
          this.item.selectedMaterialCodeData = null;
          this.item.unitName = null;
          $(this.$refs.materialCode.$refs.select).val("").trigger("change");
          return;
        }
      } else {
        this.item.unitName = null;
        delete this.item.selectedMaterialCodeData;
      }

      var $form = $("#" + id).parents("form");
      $form.validate().element("#" + id);
    },
    onBarcodeStatusChange(id, value, data, ref) {
      this.barcodeStatus = value;

      // ตรวจสอบซ้ำ: สถานะบาร์โค้ด + สินค้า
      if (this.item.materialCode && this.checkDuplicateAuditStockItem(this.item.materialCode, value)) {
        this.item.barcodeStatus = null;
        this.barcodeStatus = null;
        $(this.$refs.barcodeStatus.$refs.select).val("").trigger("change");
        return;
      }

      var $form = $("#" + id).parents("form");
      $form.validate().element("#" + id);
    },
  },
  mounted() {
    
     
    $(".required", this.$el).each(function() {
      const $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required"),
        },
      });
    });

    $(".min", this.$el).each(function() {
      const $input = $(this);
      $input.rules("add", {
        min: true,
        messages: {
          min: $input.data("msg-min"),
        },
      });
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Job/JobItemRow.vue